<template>
  <div class="product-datail-content" ref="detailRef">
    <div class="detail-title">{{ productDetail.productName }}</div>
    <div
      class="detail-content"
      v-lazy-container="{ selector: 'img' }"
      v-html="filterDeatilCss(productDetail.details)"
    ></div>
  </div>
</template>

<script>
import http from "@/axios/index.js";
export default {
  name: "product-datail",
  props: {
    msg: String,
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 100,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      productDetail: {},
    };
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    // if (Object.keys(this.$route.params).length) {
    //   window.localStorage.setItem(
    //     "productDetail",
    //     JSON.stringify(this.$route.params)
    //   );
    // }
  },
  mounted() {
    // if (window.localStorage.getItem("productDetail")) {
    //   this.productDetail = JSON.parse(
    //     window.localStorage.getItem("productDetail")
    //   );
    // }
    // 本地没有数据对象但存在productId的情况下 代表为推广页面的直接跳转
    // 这个时候调用一遍商品的详情数据 再筛选出对应ID的值显示在详情页面
    if (
      Object.keys(this.productDetail).length == 0 &&
      this.$route.query.productId
    ) {
      // 获取U鱼数智化产品
      const url = `/frontProductDescription/null`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            console.log(res.data);
            this.productDetail = res.data.filter((item) => {
              if (item.id === this.$route.query.productId) {
                return item;
              }
            })[0];
            window.localStorage.setItem(
              "productDetail",
              JSON.stringify(this.productDetail)
            );
            this.videoSrcFilter()
          }
        })
        .catch((res) => {
          console.log(res);
        });
    }

    this.$refs.detailRef.scrollTop = 0;
  },
  methods: {
    videoSrcFilter(){
      this.$nextTick(() => {
        let videos=document.querySelectorAll('video')
        for (let i = 0; i < videos.length; i++) {
          if(videos[i].dataset.src){
            videos[i].src=videos[i].dataset.src
          }
        }
      });
    },
    filterDeatilCss(detail) {
      if (detail) {
        detail = detail.replace(
          /\<img/g,
          '<img style="width:50rem;height:auto;margin-left: auto; margin-right: auto;display:block"'
        );
        detail = detail.replace(
          /\<span/g,
          '<span style="font-family: Alibaba PuHuiTi;font-size: 2rem;"'
        );
        detail = detail.replace(
          /\<video/g,
          '<video style="width:50rem;height:auto;margin:auto;display:block;" preload="auto" loop controls playsinline webkit-playsinline muted autoplay'//
        );
        detail = detail.replace(/\<li/g, '<li style="list-style:unset;"');
        detail = detail.replace(/src/g, "data-src");
        return detail;
      }
    },
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.product-datail-content {
  box-sizing: border-box;
  padding: 8rem 4rem 4.8rem 4rem;
  overflow-x: hidden;
  .detail-title {
    box-sizing: border-box;
    padding-bottom: 4rem;
    text-align: center;
    font-size: 4.2rem;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2b2b2b;
  }
  .detail-content {
    box-sizing: border-box;
    padding-top: 3rem;
    font-size: 2rem;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #2b2b2b;
  }
}
</style>
